import React from 'react';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';

const CTASection = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center scroll-animate">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Need Help <span className="text-red-500">Today</span>? <br />
            Let's Get It <span style={{ color: '#FFD700' }}>Done</span>.
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-10">
            Repairs, installs, moving help, assembly, heavy lifting, and extra hands — done safely and professionally.
          </p>
          <Button 
            className="bg-red-600 hover:bg-red-700 text-white font-bold px-10 py-7 text-xl transition-all duration-300 transform hover:scale-105 shadow-2xl shadow-red-600/50"
            onClick={() => window.location.href = 'tel:8134491138'}
          >
            <Phone className="w-6 h-6 mr-3" />
            Call (813) 449-1138
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
